import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, UserCheck, ExternalLink } from "lucide-react";
import { api } from "../lib/api";

// Page admin : génère un token « passe-partout » (accès total) et ouvre le portail membre.
export default function ApercuMembre() {
  const [status, setStatus] = useState("loading");

  const launch = async () => {
    setStatus("loading");
    try {
      const { data } = await api.post("/member/admin/preview-token");
      localStorage.setItem("member_token", data.token);
      localStorage.setItem("member_profile", JSON.stringify(data.member));
      setStatus("ready");
      toast.success("Compte passe-partout prêt — ouverture du portail membre…");
      setTimeout(() => { window.location.href = data.portal_url || "/membres"; }, 700);
    } catch (e) {
      setStatus("error");
      toast.error(e?.response?.data?.detail || "Impossible de générer l'aperçu membre.");
    }
  };

  useEffect(() => { launch(); }, []);

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="apercu-membre">
      <div className="max-w-md w-full text-center border border-zinc-800 rounded-2xl p-8 bg-zinc-900/40">
        <div className="w-14 h-14 rounded-full bg-amber-600/20 flex items-center justify-center mx-auto mb-4">
          <UserCheck className="w-7 h-7 text-amber-400" />
        </div>
        <h1 className="text-2xl font-black text-zinc-100">Aperçu membre — accès total</h1>
        <p className="text-sm text-zinc-400 mt-2">
          Un compte « passe-partout » avec accès à toutes les disciplines et sections membres,
          pour vivre l'expérience membre et repérer les corrections à faire.
        </p>
        {status === "loading" && (
          <div className="mt-6 flex items-center justify-center gap-2 text-amber-300">
            <Loader2 className="w-5 h-5 animate-spin" /> Préparation…
          </div>
        )}
        {status === "ready" && (
          <a href="/membres" className="mt-6 inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-500 text-black font-semibold px-5 py-3 rounded-xl" data-testid="open-portal-btn">
            <ExternalLink className="w-4 h-4" /> Ouvrir le portail membre
          </a>
        )}
        {status === "error" && (
          <button onClick={launch} className="mt-6 inline-flex items-center gap-2 border border-zinc-600 text-zinc-200 px-5 py-3 rounded-xl" data-testid="retry-preview-btn">
            Réessayer
          </button>
        )}
        <p className="text-[11px] text-zinc-600 mt-6">
          Note : ceci te connecte au portail membre (<code>/membres</code>) dans cet onglet. Pour revenir à l'admin, retourne sur <code>/app</code>.
        </p>
      </div>
    </div>
  );
}
